<template>
  <v-menu v-model="menu" :close-on-content-click="false" max-height="50%" offset-y min-width="80%">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="secondary" v-bind="attrs" v-on="on" tile depressed class="primary--text px-2">
        {{ $t("filtros") }}
        <v-badge v-if="filtradosActivos > 0" inline :content="filtradosActivos"/>
        <v-spacer/>
        <v-icon large>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card class="ma-0" color="grey lighten-3">
      <v-row no-gutters>
        <template v-for="(filtro, i) in filtrosLocal">
          <v-col :key="i" :cols="esMovil ? 12 : 3" class="pt-2 pb-4">
            <p class="text-decoration-underline primary--text pl-6 font-weight-bold">{{ $t(filtro.nombre) }}</p>
            <v-checkbox :key="j" class="pl-4" v-for="(item,j) in filtro.valores" v-model="filtro.model"
                        :label="item.nombre" :value="item.codigo" hide-details/>
          </v-col>
          <v-divider v-if="i !== (filtrosLocal.length - 1) && !esMovil" :key="`divider-${i}`" vertical
                     class="my-12 primary"/>
        </template>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {mapState} from "vuex";

export default {
  name: "FiltroMenuMaterial",
  props: {
    esBiblioteca: {type: Boolean, default: false, required: false},
    solucionConstructiva: {type: Object, default: null, required: false},
    filtros: {type: Array, required: true}
  },
  model: {
    prop: "filtros",
    event: "actualizado"
  },
  data() {
    return {
      menu: false,
      filtrosLocal: [
        {nombre: "uso", model: [], valores: []},
        {
          nombre: "material", model: [], valores: [
            {"codigo": "ceramicos", "nombre": this.$t("ceramico")},
            {"codigo": "noCeramicos", "nombre": this.$t("no-ceramico")}
          ]
        },
        {nombre: "tipo_ceramico", model: [], valores: []},
        {
          nombre: "tipo_producto", model: [], valores: [
            {"codigo": "publico", "nombre": this.$t("publico")},
            {"codigo": "privado", "nombre": this.$t("privado")}
          ]
        },
      ],
    }
  },
  computed: {
    ...mapState(["usuario"]),
    hayUsuario() {
      return this.usuario != null;
    },
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    filtradosActivos() {
      let activos = 0;
      this.filtrosLocal.forEach((val) => {
        if (val.model.length > 0) activos++;
      });

      return activos;
    }
  },
  mounted() {
    if (this.esBiblioteca) {
      if (!this.hayUsuario) this.filtrosLocal.pop()
      else this.addFiltroVisibilidad()
    }
    this.cargarUsos();
    this.cargarMaterialesCeramicos();
  },
  watch: {
    filtrosLocal: {
      handler() {
        this.$emit('actualizado', this.filtrosLocal);
      },
      deep: true
    },
    solucionConstructiva: {
      handler(val) {
        if (val) this.anyadirUsoPorSolCons(val);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    cargarUsos() {
      HttpHelper.get("material-personalizado/usos")
          .then((resp) => {
            this.filtrosLocal[0].valores = resp;
            if (this.solucionConstructiva) this.anyadirUsoPorSolCons(this.solucionConstructiva);
          });
    },
    cargarAbsorcionAgua() {
      HttpHelper.get("material-personalizado/absorcion-agua")
          .then((resp) => {
            this.filtrosLocal[2].valores = resp;
          });
    },
    cargarMaterialesCeramicos() {
      HttpHelper.get("material-personalizado/materiales-ceramicos")
          .then((resp) => {
            this.filtrosLocal[2].valores = resp;
          });
    },
    addFiltroVisibilidad() {
      this.filtrosLocal[3].valores.push({"codigo": "publico-propio", "nombre": this.$t("publico_propio")})
    },
    anyadirUsoPorSolCons(solCons) {
      this.filtrosLocal[0].valores.forEach((uso) => {
        uso.referencias.forEach((usoSolCons) => {
          if (usoSolCons.codigo === solCons.codigo) this.filtrosLocal[0].model.push(uso.codigo);
        });
      });
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "uso": "Uso",
    "absorcion_agua": "Absorción agua",
    "tipo_ceramico": "Tipo material cerámico",
    "tipo_producto": "Tipo de producto",
    "ceramico": "Cerámico",
    "no-ceramico": "No cerámico",
    "publico": "Público",
    "privado": "Privado",
    "publico_propio": "Público propio",
    "filtros": "Filtros"
  }
}
</i18n>
<!--@formatter:oon-->